import { trackEvent } from '../utils/analytics';
import { downloadFile } from '../utils/download-file';

// Download button for the product's custom.custom_template file
// (snippets/product-side-download-template.liquid).
class TemplateDownload extends HTMLElement {
  connectedCallback(): void {
    if (this.dataset.initialized) return;
    this.dataset.initialized = 'true';

    const button = this.querySelector<HTMLButtonElement>('[data-template-download]');
    const url = this.dataset.url;
    if (!button || !url) return;

    button.addEventListener('click', async () => {
      trackEvent('template_download', { section: 'product_side', product: this.dataset.filename ?? '' });
      await downloadFile(
        url,
        this.dataset.filename || 'template',
        button,
        this.querySelector<HTMLElement>('.template-download__loader')
      );
    });
  }
}

if (!customElements.get('template-download')) {
  customElements.define('template-download', TemplateDownload);
}
